module.exports = __webpack_public_path__ + "static/callendar-photo-e1072301790d2973a4bd819b7dd102ef.jpg";